import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_CHECK_OUTS_LOCK_BEGIN,
  MANAGE_SUBS_CHECK_OUTS_LOCK_SUCCESS,
  MANAGE_SUBS_CHECK_OUTS_LOCK_FAILURE,
  MANAGE_SUBS_CHECK_OUTS_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function checkOutsLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_CHECK_OUTS_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/checkOutsLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_CHECK_OUTS_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_CHECK_OUTS_LOCK_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckOutsLockError() {
  return {
    type: MANAGE_SUBS_CHECK_OUTS_LOCK_DISMISS_ERROR,
  };
}

export function useCheckOutsLock() {
  const dispatch = useDispatch();

  const { checkOutsLockPending, checkOutsLockError } = useSelector(
    state => ({
      checkOutsLockPending: state.manageSubs.checkOutsLockPending,
      checkOutsLockError: state.manageSubs.checkOutsLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(checkOutsLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckOutsLockError());
  }, [dispatch]);

  return {
    checkOutsLock: boundAction,
    checkOutsLockPending,
    checkOutsLockError,
    dismissCheckOutsLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_CHECK_OUTS_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkOutsLockPending: true,
        checkOutsLockError: null,
      };

    case MANAGE_SUBS_CHECK_OUTS_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        checkOutsLockPending: false,
        checkOutsLockError: null,
      };

    case MANAGE_SUBS_CHECK_OUTS_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        checkOutsLockPending: false,
        checkOutsLockError: action.data.error,
      };

    case MANAGE_SUBS_CHECK_OUTS_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkOutsLockError: null,
      };

    default:
      return state;
  }
}
